import React from "react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import UserInitials, { UnassignedIcon } from "../comments/UserInitials";
import UserName from "../users/UserName";
import { TableCell } from "./TableCellStyles";

export interface AssignedToUser {
  firstName: string;
  lastName: string;
  active: boolean;
}

export interface AssignedToCellProps {
  assignedTo?: AssignedToUser | null;
  minWidth?: number;
}

export const AssignedToCell: React.FC<AssignedToCellProps> = ({ assignedTo, minWidth }) => {
  if (!assignedTo || (!assignedTo.firstName && !assignedTo.lastName)) {
    return (
      <TableCell minWidth={minWidth}>
        <UnassignedContainer>
          <UnassignedIcon type="small" />-
        </UnassignedContainer>
      </TableCell>
    );
  }
  return (
    <TableCell minWidth={minWidth}>
      <AssignedUserContainer>
        <UserInitials
          firstName={assignedTo.firstName}
          lastName={assignedTo.lastName}
          type="small"
        />
        <AssignedUserName>
          <UserName user={assignedTo} />
        </AssignedUserName>
      </AssignedUserContainer>
    </TableCell>
  );
};

export const AssignedUserContainer = styled(Flex)({
  alignItems: "center",
  gap: "8px",
  minWidth: 0,
});

export const AssignedUserName = styled.span({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const UnassignedContainer = styled(Flex)({
  alignItems: "center",
  gap: "8px",
});
